import { render, staticRenderFns } from "./FavoriteTeam.vue?vue&type=template&id=767ea66f"
import script from "./FavoriteTeam.vue?vue&type=script&lang=js"
export * from "./FavoriteTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports